import * as THREE from 'three';

const fps = 60;

function modifiedKey(key: string): string {
  if (
    [
      "eyeLookDownLeft",
      "eyeLookDownRight",
      "eyeLookInLeft",
      "eyeLookInRight",
      "eyeLookOutLeft",
      "eyeLookOutRight",
      "eyeLookUpLeft",
      "eyeLookUpRight",
    ].includes(key)
  ) {
    return key;
  }

  if (key.endsWith("Right")) {
    return key.replace("Right", "_R");
  }
  if (key.endsWith("Left")) {
    return key.replace("Left", "_L");
  }
  return key;
}

export const createAnimation = (
  recordedData: any[],
  morphTargetDictionary: any,
  bodyPart: string
): THREE.AnimationClip | null => {
  console.log('createAnimation called with:', {
    recordedDataLength: recordedData?.length,
    morphTargetDictionaryKeys: Object.keys(morphTargetDictionary || {}),
    bodyPart
  });

  if (!recordedData || recordedData.length === 0) {
    console.log('No recorded data, returning null');
    return null;
  }

  let animation: number[][] = [];
  for (let i = 0; i < Object.keys(morphTargetDictionary).length; i++) {
    animation.push([]);
  }
  
  let time: number[] = [];
  let finishedFrames = 0;
  
  recordedData.forEach((d, i) => {
    if (!d.blendshapes) {
      console.warn(`Frame ${i} missing blendshapes`);
      return;
    }
    
    Object.entries(d.blendshapes).forEach(([key, value]) => {
      if (!(modifiedKey(key) in morphTargetDictionary)) {
        return;
      }

      let adjustedValue = value as number;
      if (key === "mouthShrugUpper") {
        adjustedValue += 0.4;
      }

      animation[morphTargetDictionary[modifiedKey(key)]].push(adjustedValue);
    });
    
    time.push(finishedFrames / fps);
    finishedFrames++;
  });

  let tracks: THREE.NumberKeyframeTrack[] = [];

  // Create morph animation tracks
  Object.entries(recordedData[0].blendshapes).forEach(([key, value]) => {
    if (!(modifiedKey(key) in morphTargetDictionary)) {
      return;
    }

    let i = morphTargetDictionary[modifiedKey(key)];
    
    let track = new THREE.NumberKeyframeTrack(
      `${bodyPart}.morphTargetInfluences[${i}]`,
      time,
      animation[i]
    );

    tracks.push(track);
  });

  console.log('Created animation with tracks:', tracks.length);
  const clip = new THREE.AnimationClip("animation", -1, tracks);
  return clip;
}; 